import {Suspense} from 'react'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {TimelinePanelContent} from './TimelinePanelContent'
import {TimelinePanelSkeleton} from './TimelinePanelSkeleton'
import styles from './TimelinePanel.module.css'

function TimelinePanelError() {
  return <div className={styles.emptyState}>Unable to load activity.</div>
}

export function TimelinePanel() {
  return (
    <ErrorBoundary boundaryName="TimelinePanel" fallback={<TimelinePanelError />}>
      <Suspense fallback={<TimelinePanelSkeleton count={25} />}>
        <TimelinePanelContent />
      </Suspense>
    </ErrorBoundary>
  )
}
